import Vue from 'vue';

const getClient = () => Vue.api.getClient('announcement');

export const STATUS = {
  LOADING: 'announcements.status.loading',
  SUCCESS: 'announcements.status.success',
  SIGNED_SUCCESS: 'announcements.status.signed.success',
  ERROR: 'announcements.status.error',
};

const initialState = {
  list: [],
  status: '',
  error: null,
  create: false,
};

const mutations = {
  setAnnouncements(state, list) {
    state.list = list;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setError(state, error) {
    state.error = error;
  },
  setCreate(state, create) {
    state.create = create;
  },
};

const actions = {
  async load({ commit }, { location, signedIn = false }) {
    try {
      commit('setStatus', STATUS.LOADING);
      const filters = { location };
      if (signedIn === true) {
        filters.internal = false;
      }
      const announcements = await getClient().list(0, 5, filters, 'POSTED_DATE DESC');
      commit('setAnnouncements', announcements.list || []);
      commit('setStatus', signedIn ? STATUS.SIGNED_SUCCESS : STATUS.SUCCESS);
      commit('setCreate', true);
    } catch (ex) {
      console.error('exception occurred retrieving announcements', ex);
      commit('setError', ex);
      commit('setStatus', STATUS.ERROR);
      commit('setAnnouncements', []);
      commit('setCreate', false);
    }
  },
  add({ commit }, { listAnnouncements }) {
    try {
      commit('setStatus', STATUS.LOADING);
      commit('setAnnouncements', listAnnouncements || []);
      commit('setStatus', STATUS.SUCCESS);
      commit('setCreate', true);
    } catch (ex) {
      console.error('exception occurred retrieving announcements', ex);
      commit('setError', ex);
      commit('setStatus', STATUS.ERROR);
      commit('setAnnouncements', []);
      commit('setCreate', false);
    }
  },
};

const getters = {
  list: (state) => state.list,
  status: (state) => state.status,
  create: (state) => state.create,
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
